// without trailing slash.
// eg '', 'http://server', 'https://server/api', '//server'
export const API_URL = '/api'